import { useState, useEffect } from 'react';
import { apiCallsStreetCategory } from "../api/calls/streetCategory"

export const useStreets = () => {
    const [streets, setStreets] = useState([]);

    useEffect(() => {
        const fetchStreets = async () => {
            try {
                const result = await apiCallsStreetCategory.Actions.GetCountDevices();
                setStreets(result || []);
            } catch (err) {
                console.error("Error fetching devices:", err);
                setStreets([]);
            }
        };
        fetchStreets();
    }, []); 

    return streets;
}